import React, {useState, useEffect, useContext} from "react";
import "./Blog.scss";
import BlogCard from "../../components/blogCard/BlogCard";
import {blogSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
const COLLAPSED_COUNT = 3;

export default function Blogs() {
  const {isDark} = useContext(StyleContext);
  const [mediumBlogs, setMediumBlogs] = useState([]);
  const [expanded, setExpanded] = useState(false);
  function setMediumBlogsFunction(array) {
    setMediumBlogs(array);
  }
  //Medium API returns blogs' content in HTML format. Below function extracts blogs' text content within paragraph tags
  function extractTextContent(html) {
    return typeof html === "string"
      ? html
          .split("p>")
          .filter(el => !el.includes(">"))
          .map(el => el.replace("</", ".").replace("<", ""))
          .join(" ")
      : NaN;
  }
  useEffect(() => {
    if (blogSection.displayMediumBlogs === "true") {
      const getProfileData = () => {
        fetch("/blogs.json")
          .then(result => {
            if (result.ok) {
              return result.json();
            }
          })
          .then(response => {
            setMediumBlogsFunction(response.items);
          })
          .catch(function (error) {
            console.error(
              `${error} (because of this error Blogs section could not be displayed. Blogs section has reverted to default)`
            );
            setMediumBlogsFunction("Error");
            blogSection.displayMediumBlogs = "false";
          });
      };
      getProfileData();
    }
  }, []);
  if (!blogSection.display) {
    return null;
  }

  const useMedium =
    blogSection.displayMediumBlogs === "true" && mediumBlogs !== "Error";
  const allBlogs = useMedium ? mediumBlogs : blogSection.blogs;
  const visibleBlogs = expanded ? allBlogs : allBlogs.slice(0, COLLAPSED_COUNT);
  const hiddenCount = Math.max(allBlogs.length - COLLAPSED_COUNT, 0);

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="blogs">
        <div className="blog-header">
          <h1 className="blog-header-text">{blogSection.title}</h1>
          <p
            className={
              isDark ? "dark-mode blog-subtitle" : "subTitle blog-subtitle"
            }
          >
            {blogSection.subtitle}
          </p>
        </div>
        <div className="blog-main-div">
          <div className="blog-text-div">
            {useMedium
              ? visibleBlogs.map((blog, i) => (
                  <BlogCard
                    key={i}
                    isDark={isDark}
                    blog={{
                      url: blog.url,
                      title: blog.title,
                      description: extractTextContent(blog.content)
                    }}
                  />
                ))
              : visibleBlogs.map((blog, i) => (
                  <BlogCard
                    key={i}
                    isDark={isDark}
                    blog={{
                      url: blog.url,
                      image: blog.image,
                      title: blog.title,
                      description: blog.description
                    }}
                  />
                ))}
          </div>
        </div>

        {hiddenCount > 0 && (
          <div className="blog-toggle-div">
            <button
              className={isDark ? "dark-mode blog-toggle-btn" : "blog-toggle-btn"}
              onClick={() => setExpanded(e => !e)}
              aria-expanded={expanded}
            >
              {expanded
                ? "Show less ↑"
                : `Show ${hiddenCount} more ${
                    hiddenCount === 1 ? "post" : "posts"
                  } ↓`}
            </button>
          </div>
        )}
      </div>
    </Fade>
  );
}
